import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import { formatPhoneNumber } from '@/app/module/conversations/format-helpers'
import { ContactType } from '@/app/module/conversations/types'
import { formatDate } from '@/app/service/util'
import { formatName } from '@/app/service/util/format'

type Props = {
  isActive: boolean
  contact: ContactType
  setActiveContact: (id: number) => void
}

const Contact: React.FC<Props> = (props) => {
  const { isActive, contact, setActiveContact } = props
  return (
    <Container
      $active={isActive}
      className="conversations-contact-wrapper"
      onClick={() => {
        setActiveContact(contact.contactId)
      }}
    >
      <ContactInfo>
        {(contact.firstName || contact.lastName) && (
          <div>
            <Typography variant="subtitle1">{formatName(contact.firstName, contact.lastName)}</Typography>
          </div>
        )}
        <div>
          <Typography variant="subtitle1" color="textSecondary">
            {formatPhoneNumber(contact.contactId, contact.countryCode, contact.fullPhoneNumber)}
          </Typography>
        </div>
      </ContactInfo>
      <ContactRightSide>
        <UnreadCountContainer
          style={{
            visibility: contact.unreadCount > 0 ? 'visible' : 'hidden',
          }}
        >
          <UnreadCount>
            <strong>{contact.unreadCount}</strong>
          </UnreadCount>
        </UnreadCountContainer>
        <Typography variant="caption" color="textSecondary">
          {formatDate(contact.created)}
        </Typography>
      </ContactRightSide>
    </Container>
  )
}

const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== '$active',
})<{ $active: boolean }>(({ theme, $active }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '10px 20px',
  borderBottom: `1px solid ${theme.palette.border.main}`,
  cursor: 'pointer',
  backgroundColor: $active ? theme.palette.highlight.light : 'transparent',
  '&:hover, &:focus': {
    backgroundColor: theme.palette.highlight.light,
  },
}))

const ContactInfo = styled('div')(() => ({
  alignItems: 'center',
  maxWidth: '200px',
}))

const ContactRightSide = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingBottom: '2px',
  paddingTop: '6px',
}))

const UnreadCountContainer = styled('div')(() => ({
  textAlign: 'right',
  width: '100%',
}))

const UnreadCount = styled('div')(({ theme }) => ({
  borderRadius: '50%',
  background: theme.palette.primary.main,
  color: '#fff',
  width: '16px',
  height: '16px',
  padding: '.2em 0px',
  fontSize: '12px',
  lineHeight: '1em',
  fontWeight: 500,
  textAlign: 'center',
  float: 'right',
}))

export default Contact
